import React from 'react';
import styles from './Footer.module.scss';
import sns_medi_bottom from "../../assets/images/icon/sns_medi_bottom.svg";
import sns_tele_bottom from "../../assets/images/icon/sns_tele_bottom.svg";
import sns_twit_bottom from "../../assets/images/icon/sns_twit_bottom.svg";
import logo_wh from "../../assets/images/logo_ontel_wh.svg";
const Footer = () => (
    <footer className={`w-100 p-5`}>
        <div className={`d-flex justify-content-between align-items-center p-5`}>
            <div className={styles.logo_box}>
                <img src={logo_wh} style={{width: '200px'}} alt={`logo_img`}/>
                <p className={`my-3`}>COPYRIGHT © ONTELLABS, All RIGHTS RESERVED.</p>
            </div>
            <div className={styles.sns_box}>
                <div>
                    <a href={`https://ontel-foundation-ltd.gitbook.io/ontel/`} target={`_blank`}>WHITEPAPER</a>
                    <a href={`javascript:alert('준비중입니다.')`}>MARKET PLACE</a>
                    <a href={`javascript:alert('준비중입니다.')`}>SWAP</a>
                </div>
                <div>
                    <a href="https://t.me/ONTELoffical" target="_blank" rel={`noreferer`}><img src={sns_tele_bottom} alt="tel link"/></a>
                    <a href="https://medium.com/@ONTELofficial" target="_blank" rel={`noreferer`}><img src={sns_medi_bottom} alt="medium link"/></a>
                    <a href="https://twitter.com/ONTELofficial" target="_blank" rel={`noreferer`}><img src={sns_twit_bottom} alt="twitter link"/></a>
                </div>
            </div>
            <div className={`text-end`}>
                <a href={`mailto:ontel@ontellabs.com`} className={`my-3`}>ontel@ontellabs.com</a>
            </div>
        </div>
    </footer>
);

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
